import type { Customer } from '../../../../mocks/crm';
import { agencyInfo } from '../../../../mocks/dashboard';

const brand = agencyInfo.brandColor;

interface CustomerListProps {
  customers: Customer[];
  selected: Customer | null;
  onSelect: (c: Customer) => void;
  search: string;
  onSearch: (s: string) => void;
}

export default function CustomerList({ customers, selected, onSelect, search, onSearch }: CustomerListProps) {
  return (
    <div className="w-80 flex-shrink-0 flex flex-col border-r border-gray-100 bg-white">
      {/* Search */}
      <div className="p-4 border-b border-gray-100">
        <div className="relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
          <input
            type="text"
            placeholder="Search customers..."
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 bg-gray-50 placeholder-gray-400"
            style={{ '--tw-ring-color': brand } as React.CSSProperties}
          />
        </div>
        <p className="text-xs text-gray-400 mt-2">{customers.length} customers</p>
      </div>

      {/* List */}
      <div className="flex-1 overflow-y-auto">
        {customers.length === 0 && (
          <div className="flex flex-col items-center justify-center py-16 px-4">
            <i className="ri-contacts-book-2-line text-3xl text-gray-300 mb-2" />
            <p className="text-sm text-gray-400">No customers found</p>
          </div>
        )}
        {customers.map((c) => {
          const isSelected = selected?.id === c.id;
          return (
            <button
              key={c.id}
              onClick={() => onSelect(c)}
              className={`w-full text-left px-4 py-3.5 border-b border-gray-50 cursor-pointer transition-all flex items-start gap-3 ${
                isSelected ? '' : 'hover:bg-gray-50'
              }`}
              style={isSelected ? { backgroundColor: `${brand}08`, borderLeft: `3px solid ${brand}` } : {}}
            >
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0 mt-0.5"
                style={{ backgroundColor: isSelected ? brand : '#94A3B8' }}
              >
                {c.avatar}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-1 mb-0.5">
                  <p className={`text-sm font-semibold truncate ${isSelected ? '' : 'text-gray-800'}`} style={isSelected ? { color: brand } : {}}>
                    {c.name}
                  </p>
                  {c.tags.includes('VIP') && (
                    <span className="text-xs font-bold px-1.5 py-0.5 rounded-full flex-shrink-0" style={{ backgroundColor: '#FFF7ED', color: '#D97706' }}>
                      VIP
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-400 truncate">{c.email}</p>
                <div className="flex items-center gap-3 mt-1.5">
                  <div className="flex items-center gap-1 text-gray-500">
                    <i className="ri-suitcase-line text-xs" />
                    <span className="text-xs">{c.totalBookings} trips</span>
                  </div>
                  <div className="flex items-center gap-1 text-gray-500">
                    <i className="ri-money-dollar-circle-line text-xs" />
                    <span className="text-xs">{c.totalSpent}</span>
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
